<template>
  <div class="index">
    <div class="head">
      <el-image class="logo" src="https://mall-static.yqslmall.com/20230208-153813.png" fit="fill"></el-image>
      <div class="nav">
        <router-link class="name" to="/home">首页</router-link>
        <router-link class="name" to="/news">元气资讯</router-link>
        <router-link class="name" to="/contactUs">联系我们</router-link>
      </div>
    </div>
    <div class="con">
      <router-view />
    </div>
    <footer-intr />
  </div>
</template>
<script>
import footerIntr from '@/components/footer'
export default {
  components: { footerIntr },
}
</script>
<style lang="scss">
.index {
  position: relative;
  min-width: 1080px;
  width: calc(100% - 80px);
  min-height: calc(100% - 171px);
  background: #fff3ed;
  padding: 37px 40px 134px;
  .head {
    display: flex;
    flex-direction: row;
    .logo {
      width: 184px;
      height: 33px;
      img {
        width: 184px;
      height: 33px;
      }
    }
    .nav {
      display: flex;
      flex-direction: row;
      padding-left: 60px;
      font-size: 24px;
      font-weight: 400;
      a {
        color: rgba(255, 100, 25, 0.5);
        padding-right: 40px;
        cursor: pointer;
        font-family: SourceHanSansSC-Regular, SourceHanSansSC;
        text-decoration: none;
      }
      .router-link-exact-active,
      .router-link-active {
        color: rgba(255, 100, 25, 1);
        font-weight: bold;
      }
    }
  }
  .con {
    display: flex;
    justify-content: center;
    // padding: 0 250px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index.vue